export default "__VITE_ASSET__f808aff8__"